export default {
    REFRESH_PATIENT_PROFILE: "refresh-patient-profile"
};